export const ADD_BOOKING = "booking/addBooking";
export const DELETE_BOOKING = "booking/deleteBooking";
